module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=ER - Eritrea.d29c2cc4.svg";